const HELP_ARTICLE_URL = 'https://pomoc.caterings.pl/article';

const EXTERNAL_URLS = {
  addons: `${HELP_ARTICLE_URL}/133-dodatki`,
  bannerImage: `${HELP_ARTICLE_URL}/366-zalecane-ustawienia-w-zakresie-konfiguracji-panelu-klienta#:~:text=Zoptymalizuj%20wielko%C5%9B%C4%87%20baneru`,
  baskets: `${HELP_ARTICLE_URL}/228-koszyki`,
  configurationApplePay: `${HELP_ARTICLE_URL}/489-konfiguracja-apple-pay`,
  configurationGooglePay: `${HELP_ARTICLE_URL}/78-konfiguracja-google-pay`,
  configurationMontonio: `${HELP_ARTICLE_URL}/429-konfiguracja-platnosci-montonio`,
  configurationOrderForm: `${HELP_ARTICLE_URL}/231-formularz-zamowienia`,
  configurationPayNow: `${HELP_ARTICLE_URL}/123-konfiguracja-paynow`,
  configurationStripe: `${HELP_ARTICLE_URL}/77-konfiguracja-bramki-stripe`,
  daysOut: `${HELP_ARTICLE_URL}/356-wylaczanie-dni-z-zamowien`,
  deactivateDiet: `${HELP_ARTICLE_URL}/222-jak-dezaktywowac-diete-kiedy-dieta-jest-aktywna-dla-klientow`,
  discountCode: `${HELP_ARTICLE_URL}/271-kody-rabatowe`,
  platformBrand: `${HELP_ARTICLE_URL}/344-foodsi-pakowanie-diety-do-kilku-toreb`,
  goodspeedIntegration: `${HELP_ARTICLE_URL}/286-integracja-z-goodspeed`,
  howDeliveryDiscountWorks: `${HELP_ARTICLE_URL}/137-jak-dziala-rabat-za-wspolna-dostawe`,
  individualMultiplier: `${HELP_ARTICLE_URL}/279-lista-zakupow#Definiowanie-wspczynnikw-dla-pojedynczych-pozycji-matrycy-m-RH9`,
  information: `${HELP_ARTICLE_URL}/229-informacje`,
  invoiceConfig: `${HELP_ARTICLE_URL}/187-konfiguracja-fakturowni`,
  languageSettings: `${HELP_ARTICLE_URL}/131-modul-tlumaczen#Ustawienia_jzykowe`,
  mailNotifications: `${HELP_ARTICLE_URL}/239-powiadomienia-mailowe`,
  mailReminders: `${HELP_ARTICLE_URL}/240-przypomnienia-mailowe`,
  marketingConsentsUpdate: `${HELP_ARTICLE_URL}/419-zmiany-w-modelu-zarzadzenia-zgod-marketingowych`,
  mealsCodingVersion: `${HELP_ARTICLE_URL}/80-sposoby-pakowania-toreb-z-caterings`,
  multipliersMatrix: `${HELP_ARTICLE_URL}/279-lista-zakupow#Matryca-wspczynnikw-wspczynniki-indywidualne-per-dieta-kJuPS`,
  payUPaymentConfig: `${HELP_ARTICLE_URL}/132-konfiguracja-sklepu-payu`,
  paymentMethod: `${HELP_ARTICLE_URL}/233-metody-platnosci`,
  points: `${HELP_ARTICLE_URL}/258-konfiguracja-skarbonki`,
  recipes: `${HELP_ARTICLE_URL}/120-czym-jest-przepis-w-caterings`,
  sharedMultiplier: `${HELP_ARTICLE_URL}/279-lista-zakupow#Generowanie-Listy-Zakupowej-w-oparciu-o-wspczynniki-jguWT`,
  shoppingList: `${HELP_ARTICLE_URL}/279-lista-zakupow`,
  statisticsPanelClients: `${HELP_ARTICLE_URL}/426-panel-statystyk`,
  statisticsPanelComparisons: `${HELP_ARTICLE_URL}/426-panel-statystyk#Porwnania-QpBcr`,
  subAddons: `${HELP_ARTICLE_URL}/447-system-kaucyjny-dla-dodatkow`,
  timeSettings: `${HELP_ARTICLE_URL}/196-sloty-czasowe`,
  waysOfPackingBags: `${HELP_ARTICLE_URL}/80-sposoby-pakowania-toreb-z-caterings`,
  whyCustomerAddressDoesntHaveAssignedZone: `${HELP_ARTICLE_URL}/207-dlaczego-adres-klienta-nie-ma-przypisanej-strefy`,
  whyEndedDietIsStillActive: `${HELP_ARTICLE_URL}/225-dieta-sie-skonczyla-czemu-jest-aktywna`,
  zones: `${HELP_ARTICLE_URL}/159-strefy`,
  zonesAutomaticImport: `${HELP_ARTICLE_URL}/159-strefy#Automatyczna-aktualizacja-stref-SIz-c`,
  zonesGoodspeedIntegration: `${HELP_ARTICLE_URL}/286-integracja-z-goodspeed`,
};

export default EXTERNAL_URLS;
